import React, {ReactNode} from 'react';
import {Outlet} from 'react-router-dom';
import {ChevronDownWhite} from '../../ui-components/Iconpack';
interface SideSubMenuProps {
    children?: ReactNode;
    onClose: () => void;
}
export default function SideSubMenu({children, onClose}: SideSubMenuProps) {
    return (
        <div className='fixed bottom-[90px] z-10 h-[280px] w-full overflow-y-auto bg-[#293056] px-4 pb-4 pt-[31px] md:relative md:bottom-0 md:h-full md:min-w-[236px] md:max-w-[236px]'>
            <div className='flex justify-between'>
                <div className='w-full'>
                    <Outlet />
                    {children}
                </div>
                <div className='block md:hidden' onClick={onClose}>
                    <ChevronDownWhite width={24} height={24} />
                </div>
            </div>
        </div>
    );
}
